"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewActivityAssetBase = void 0;
const Entities_1 = require("../../Entities");
class NewActivityAssetBase extends Entities_1.RequestHandler {
    castPayloadV1(payload) {
        const castPayload = payload;
        if (!castPayload.file || !castPayload.callback) {
            throw new Entities_1.UnableToParsePayload(this.requestType, 1, JSON.stringify(payload));
        }
        return castPayload;
    }
    constructor(hostHandler) {
        super();
        this.requestType = "NEW_ACTIVITY_ASSET";
        this.action = () => {
            throw new Entities_1.ActionNotImplemented(this.requestType);
        };
        this.handleRequest = (version, payload) => {
            if (version === 1) {
                const { file, callback } = this.castPayloadV1(payload);
                this.action(file, callback);
            }
            else {
                throw new Entities_1.UnsupportedRequestVerion(this.requestType, version);
            }
        };
        hostHandler.registerRequestHandler(this);
    }
}
exports.NewActivityAssetBase = NewActivityAssetBase;
